import React from "react";
import heartFull from "../assets/icons/heart.svg";


function FavoritesButton({ favorieCount, setVisibleRight }) {
    return (
        <div className="relative align-middle flex items-center">
            <img
                alt={"..."}
                className="w-8 h-auto cursor-pointer"
                src={heartFull}
                onClick={() => setVisibleRight(true)}
            />
            <div
                className="absolute w-4 h-4 text-xs text-bold bg-secondary-color text-white rounded-full top-0 right-0 flex justify-center items-center transform translate-x-1"
            >
                {favorieCount}
            </div>
        </div>
    );
}

export default FavoritesButton;
